import React from 'react';
import { IAuditoriaBeneficiosIndiretosResultado } from '../interfaces/IAuditoriaBeneficiosIndiretos';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaBeneficiosIndiretosResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Benefícios Indiretos a Sócios — varre as despesas (exceto Pró-Labore) buscando o
// nome de cada sócio do QSA (obtido ao vivo via fonte pública de CNPJ) no histórico do
// lançamento. Despesa particular do sócio lançada como despesa da empresa caracteriza Remuneração
// Indireta/Benefício Indireto, sujeita a IRRF exclusivo na fonte (35%) e Multa ECD potencial
// (5% limitada a 1% da receita bruta do período).
const AuditoriaResumoBeneficiosIndiretos: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.despesasIndevidas?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Benefícios Indiretos a Sócios</h3>
      <p className='text-muted'>
        Auditoria complementar — despesas particulares de sócios lançadas em contas de resultado (exceto
        Pró-Labore) caracterizam Remuneração Indireta/Benefício Indireto, sujeita a IRRF exclusivo na
        fonte (35%) e Multa ECD potencial (5% limitada a 1% da receita bruta do período). O quadro
        societário é obtido ao vivo via fonte pública de CNPJ.
        Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Impacto Fiscal Estimado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_BENEFICIOS_INDIRETOS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Benefícios Indiretos a Sócios</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} despesa{totalOcorrencias === 1 ? '' : 's'} com indício de benefício indireto no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>IRRF exclusivo na fonte 35% + Multa ECD potencial (5% limitada a 1% da receita bruta)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoBeneficiosIndiretos;
